import React, { useState, useEffect, useRef } from 'react';
import FlashcardList from './FlashcardList';
import './App.css'
import { Link } from 'react-router-dom';

function App() {
  const [flashcards, setFlashcards] = useState(EDURAW_FLASHCARDS)
  const [teamNumber, setTeamNumber] = useState('ONE')
  
  useEffect(() => {
   
  }, [])

  const clicked = 0

  function nextButton(e) {
    const clicked =  1;
  }
    

  return (
    <>
      
      <div className="headerTeampicker" >
          <div>
            <h1>Game Picker</h1>
          </div>
          <div>
          </div>
  
      </div>
      
      <div className="container">
        <FlashcardList flashcards={flashcards} />
      </div>
      
      {/* <div className="auth-btn-container">
        <Link className='flashcard-btn' to="/play/quiz">Let's play</Link>
      </div> */}
    </>
  );
}

const EDURAW_FLASHCARDS = [
  {
    id: 'gold',
    answer: 'Copper and Iron',
    link: 'https://eduraw-toolkit-en-cu.vercel.app/play/quiz',
  },   
  {
    id: 'silicon',
    answer: 'Gold and Silicon',
    link: 'https://eduraw-toolkit-en.vercel.app/play/quiz',
  },
  {
    id: 'gold',
    answer: 'Copper and Silicon',
    link: 'https://eduraw-toolkit-cu-si-en.vercel.app/play/quiz',
  },   
  {
    id: 'silicon',
    answer: 'Gold and Iron',
    link: 'https://eduraw-toolkit-au-fe-en.vercel.app/play/quiz',
  }


]

export default App;

